import { HttpErrorResponse } from '@angular/common/http';
import { MetaData, RetailerType } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getRetailerTypes = createAction('[RetailerTypeFilters] Get Retailer Types');

export const getRetailerTypesSuccess = createAction(
    '[RetailerTypeFilters] Get Retailer Types Success',
    props<{ retailerTypes: RetailerType[]; metadata: MetaData | null; searchText: string | null }>()
);

export const getRetailerTypesFailure = createAction(
    '[RetailerTypeFilters] Get Retailer Types Failure',
    props<{ error: HttpErrorResponse }>()
);

export const fetchRetailerTypes = createAction('[RetailerTypeFilters] Fetch Retailer Types');

export const searchRetailerTypes = createAction(
    '[RetailerTypeFilters] Get Retailer Types With Search',
    props<{ searchText: string; delay: number }>()
);

export const isLoadingRetailerTypes = createAction('[RetailerTypeFilters] Loading Retailer Types');

export const amendRetailerTypesSelections = createAction('[RetailerTypeFilters] Amend Selected Retailer Types');

export const getNextPageRetailerTypes = createAction('[RetailerTypeFilters] Get Next Page Retailer Types');

export const updateRetailerTypesSelectionSuccess = createAction(
    '[RetailerTypeFilters] Get Next Page Retailer Types Success',
    props<{ retailers: RetailerType[]; metadata: MetaData | null }>()
);
